/**
 * Ask the listbox component to re-read its checkboxes.
 *
 * The dropdown labels ("All Categories" until something is picked) are owned by
 * the listbox, but filters are also changed from outside it — the query string
 * on load, the active filter pills, and Clear Results — so those paths announce
 * the change instead of reaching into the component.
 */
const syncListboxes = () => {
	document.dispatchEvent(new CustomEvent('emListboxSync'));
};

export default syncListboxes;
